module.exports = __webpack_public_path__ + "static/media/audio.b37ea97f.mp3";